import styled from 'styled-components'

// Convertible toglie il round top del tab content perchè sono visualizzati i tab
export const TabContent = styled.div<{ convertible: boolean }>`
  background-color: ${({ theme }) => theme.colors.background};
  padding: 2rem;
  width: 100%;
  min-width: 25rem;
  max-width: 80rem;
  border-radius: ${({ convertible }) =>
    convertible ? '0 0.5rem 0.5rem 0.5rem' : '0.5rem'};

  p {
    margin: 0;
  }
`

export const Tabs = styled.div`
  width: 100%;
  min-width: 25rem;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`

export const Tab = styled.div<{ order: number; isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  order: ${({ order }) => order};
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.boxBackground : theme.colors.background};
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.primary};
  padding: 0.8rem 0;
  user-select: none;
`

export const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Row = styled.div<{ convertible: boolean; nColumn: number }>`
  display: grid;
  grid-template-columns: ${({ nColumn }) => `repeat(${nColumn}, 1fr)`};
  grid-gap: 1rem;
  &:first-child {
    border-bottom: ${({ convertible }) => !convertible && `1px solid #ccc`};
  }
`

export const SizeName = styled.div`
  &:first-child {
    text-align: center;
  }
`
